const AmazonCognitoIdentity = require('amazon-cognito-identity-js');

const poolData = {
    UserPoolId: process.env.VUE_APP_COGNITO_POOLID,
    ClientId: process.env.VUE_APP_COGNITO_CLIENTID
};
export const pool_region = process.env.VUE_APP_AWS_REGION;
export const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);